export default "__VITE_ASSET__94ad5c9f__"